
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options } from "vue-class-component";
import {
  firstCapitalize,
  formatCompactNumber,
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { CargoController } from "../../controllers/CargoController";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import router from "../../router";
import Print from "./modules/print.vue";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import {  CargoInputData, CargoFailedUnread, CargoSummaryInProcessData } from "@/domain/entities/Cargo";
import { OptionsClass } from "@/domain/entities/MainApp";
import { LocationController } from "../../controllers/LocationController";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { FailedUnreadRequest } from '@/data/payload/api/CargoApiRequest';
import { MainAppController } from "../../controllers/MainAppController";

@Options({
  components: {
    EmptyState,
    Print,
  },
  computed: {
    getTitle() {
      return this.$route.meta.name;
    },
    ableToCreate() {
      return FlagsPermissionCargo.permission_cargo_create.isEnabled();
    },
    ableToViewDetail() {
      return FlagsPermissionCargo.permission_cargo_detail_view.isEnabled();
    }
  },
  directives: {
    "click-outside": {
      beforeMount: function(el, binding) {
        const ourClickEventHandler = (event: any) => {
          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event);
          }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;
        document.addEventListener("click", ourClickEventHandler);
      },
      unmounted: function(el) {
        document.removeEventListener("click", el.__vueClickEventHandler__);
      }
    }
  }
})
export default class Cargo extends Vue {
  // Tabs
  get tabs() {
    return [
      { 
        name: "booking-success", 
        title: "Berhasil Booking" 
      },
      { 
        name: "booking-in-progress", 
        title: `Dalam Proses Booking(${formatCompactNumber(this.summaryInProcessValue)})`
      },
      { 
        name: "booking-canceled", 
        title: "Dibatalkan/Gagal Booking" 
      }
    ]
  }

  hubIdSelected: any = [];
  changeTabs(value: string) {        
    if (getHubData()?.hubId) {
      this.hubIdSelected = [
        { label: getHubData()?.hubName, value: getHubData()?.hubId }
      ];
      CargoController.setHubIdsSelected([Number(getHubData()?.hubId)]);
    } else {
      this.hubIdSelected = [];
      CargoController.setHubIdsSelected([]);
    }

    this.stopUnreadInterval();
    if (value === "booking-canceled") {
      CargoController.setCargoFailedUnreadData(
        new CargoFailedUnread({
          isShow: false,
          newRcId: CargoController.cargoFailedUnreadData.newRcId
        })
      );
      this.getCargoFailedUnread("read");
    } else {
      this.initiateGetCargoFailedUnread();
    }

    if (value !== 'booking-in-progress') {
      CargoController.setSummaryInProcess(
        new CargoSummaryInProcessData({
          inProcessTotal: 0
        })
      )
    }

    this.$router.push({
      name: value
    });

    CargoController.getCargoSummaryInProcess();
  }

  get accountIsForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }

  fetchCargoList() {
    CargoController.fetchCargoList({
      type: CargoController.cargoStatus ? "retry" : ""
    });
  }

  showModalSTTPaid = false;
  handlerModalSTTPaid(val: boolean) {
    this.showModalSTTPaid = val;
  }

  // goToCreate
  goToCreate() {
    dataLayer("booking_cargo_click", {}, [
      "userId",
      "username",
      "userType",
      "timestamp"
    ]);
    CargoController.resetCargoInputForm(new CargoInputData()); //add inital value cargo-input-data on localstorage for booking cargo
    router.push("/cargo/create");
    this.handlerModalSTTPaid(false);
    CargoController.setProgressValue(-1);
    this.getTabs();
  }

  get originCity(): OptionsClass {
    const detailDistrict = LocationController.districtDetail;
    return new OptionsClass({
      name: `${detailDistrict.cityCode} - ${firstCapitalize(
        detailDistrict.cityName.toLowerCase()
      )}`,
      code: detailDistrict.cityCode
    });
  }

  async getTabs() {
    await CargoController.getCargoOptions({
      origin: {
        code: this.originCity.code || "",
        name: this.originCity.name
      },
      destination: {
        code: "",
        name: ""
      },
      isPlaneManual: false
    });
  }

  isAdvancedFilterOpened = false;
  
  onOpenedAdvancedFilter(event: any) {
    this.isAdvancedFilterOpened = event;
  }

  get summaryInProcessValue() {
    return CargoController.summaryInProcessValue.inProcessTotal;
  }

  async mounted() {
    this.initiateGetCargoFailedUnread();
    CargoController.getCargoSummaryInProcess();

    try {
      window.requestAnimationFrame(() => {
        MainAppController.showLoading();
      })
      await AccountController._getData();
    } finally {
      MainAppController.closeLoading();
    }
  }

  unmounted() {
    this.stopUnreadInterval();
  }

  get hasNewCanceledFailed() {
    return CargoController.cargoFailedUnreadData.isShow;
  }

  getCargoFailedUnread(action: string) {
    const params = new FailedUnreadRequest({
      hubId: getHubData()?.hubId,
      action: action
    });
    CargoController.getCargoFailedUnread(params);
  }

  unreadInInterval: any = null;
  initiateGetCargoFailedUnread() {
    this.unreadInInterval = setInterval(
      () => this.getCargoFailedUnread("list"),
      FlagsPermissionCargo.config_booking_failed_indicator_pooling_rate.getValue()
    );
  }

  stopUnreadInterval() {
    clearInterval(this.unreadInInterval);
  }
}
